import React from "react";
import { Mail, MapPin, Phone } from "lucide-react";
import BrandLogo from "@/components/BrandLogo";

export default function Footer({ settings, language }) {
  const phoneHref = `tel:${settings.phone.replace(/[^0-9+]/g, "")}`;
  return (
    <footer className="footer" data-testid="site-footer">
      <div className="footer-grid">
        <div>
          <a className="footer-brand-link" href="#top" data-testid="footer-brand-link"><BrandLogo settings={settings} language={language} footer /></a>
          <span className="footer-brand-heading">{language === "en" ? <>Comfort<br />without<br />compromise.</> : <>Confort<br />sin<br />compromisos.</>}</span>
          <p className="footer-descriptor">{settings.descriptor?.[language]}</p>
        </div>
        <div><span className="footer-label">{language === "en" ? "Reach the team" : "Contacta al equipo"}</span><ul className="footer-list"><li><a href={phoneHref} data-testid="footer-phone-link"><Phone size={14} /> {settings.phone}</a></li><li><a href={`mailto:${settings.email}`} data-testid="footer-email-link"><Mail size={14} /> {settings.email}</a></li></ul></div>
        <div><span className="footer-label">{language === "en" ? "Service area" : "Área de servicio"}</span><ul className="footer-list"><li><span><MapPin size={14} /> {settings.address}</span></li><li>{settings.service_area?.[language]}</li><li><a href="/admin" data-testid="footer-admin-link">{language === "en" ? "Admin portal" : "Portal privado"}</a></li></ul></div>
      </div>
      <div className="footer-bottom"><span>© {new Date().getFullYear()} {settings.brand_name}</span><a href="#top" data-testid="footer-back-to-top-link">{language === "en" ? "Back to top ↑" : "Volver arriba ↑"}</a></div>
    </footer>
  );
}
